import type { InjectionKey, Ref } from 'vue'

import { type GetProductResponse } from '@backmarket/http-api/src/api-specs-navigation-experience/product/product'

export const PRODUCT_INJECTION_KEY = Symbol(
  'product-injection-key',
) as InjectionKey<Ref<GetProductResponse | null>>
